import renderMenuItem from "../items/render-menu-item"
import renderIcon from "../items/render-icon"
import VariantReader from "aldoo-ra/VariantReader"
import { twMerge } from "tailwind-merge"

const isInteractive = (item) => item?.options?.action || item?.link

// Component for rendering items in horizontal list mode
const HListItems = ({
  menuData,
  handleAction,
  menuItemRender,
  listLabel,
  renderAs,
  variant,
  styleOverrides,
  iconRecolor = true,
}) => {
  let { items } = menuData || {}
  if (!items) items = [menuData]

  // Determine if we should use icon rendering (without mutating original data)
  const shouldUseIconRender = renderAs.includes(".icons")

  const variants = VariantReader.useVariant({
    componentName: "Menu",
    variant: variant || renderAs,
    styleOverrides,
  })

  const { menu, menu_item } = variants

  return (
    <ul className={menu}>
      {/* Render root item if provided */}
      {listLabel && <li className={menu_item}>{listLabel(menuData)}</li>}

      {/* Render the rest of the items */}
      {items.map((item, index) => {
        const cursorPointer = isInteractive(item) ? "cursor-pointer" : ""
        return (
          <li
            key={index}
            onClick={() => handleAction(item)} // Use handleAction for item clicks
            className={twMerge(menu_item, cursorPointer)}
            role="menuitem"
          >
            {/* Choose render function without mutating original data */}
            {menuItemRender 
              ? menuItemRender(item, index)
              : shouldUseIconRender 
                ? renderIcon(item, iconRecolor)
                : renderMenuItem(item)
            }
          </li>
        )
      })}
    </ul>
  )
}

export default HListItems
